import React from "react";
import { Helmet } from "react-helmet";
import * as styles from "./Layout.module.scss";
import { HeaderContent } from "../Components/HeaderContent";
import { Features } from "../Components/Feature";
import { RepeatableContent } from "../Components/RepeatableContent";
import { renderAst } from "utilities/markdown";
import { useIsClient } from "usehooks-ts";

enum ContentBlocks {
  HeaderContent = "ContentfulLandingPageHeaderContent",
  KeyFeatures = "ContentfulKeyFeatures",
  RepeatingContent = "ContentfulLandingPageRepeatingContent",
  WidgetContainer = "ContentfulWidgetContainer",
}

type ContentBlockType =
  Queries.ContentfulKeyFeaturesContentfulLandingPageHeaderContentContentfulLandingPageRepeatingContentContentfulWidgetContainerUnion & {
    type: ContentBlocks;
  };

const LayoutNew = ({ data }) => {
  const page = data?.page
    ?.nodes?.[0] as Queries.ContentfulLandingPageNewNov2023;
  const contentBlocks = page?.contentBlocks;
  const isClient = useIsClient();

  if (!page || !isClient) {
    return null;
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
        <title>{page?.pageTitle}</title>
      </Helmet>
      <div className={styles.landingPage}>
        {contentBlocks.map((contentBlock: ContentBlockType, i: number) => (
          <div key={contentBlock?.id}>
            {contentBlock.type === ContentBlocks.HeaderContent && (
              <HeaderContent
                headerContent={
                  contentBlock as Queries.ContentfulLandingPageHeaderContent
                }
              />
            )}
            {contentBlock.type === ContentBlocks.KeyFeatures && <Features />}
            {contentBlock.type === ContentBlocks.RepeatingContent && (
              <RepeatableContent
                repeatableContent={
                  contentBlock as Queries.ContentfulLandingPageRepeatingContent
                }
                isOdd={i % 2 === 1}
              />
            )}
            {contentBlock.type === ContentBlocks.WidgetContainer && (
              <div>
                <div className={styles.widgetContent}>
                  {renderAst(
                    (contentBlock as Queries.ContentfulWidgetContainer).content
                      ?.childMarkdownRemark?.htmlAst,
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default LayoutNew;
